<template>
  <TimeUi
    label="до"
    :time="timeTo"
    :availableTimes="props.availableTimes"
    :disabled="props.disabled"
    :invalid="invalid"
    ref="timeToField"
    class="time-to input-group"
    @update:time="emit('update:timeTo', $event)"
  />
</template>

<script setup>
import { ref, toRefs } from 'vue'
import TimeUi from '@features/UI/TimeUi.vue'

const props = defineProps({
  timeTo: {
    type: String,
    required: true,
    default: '',
  },
  availableTimes: {
    type: Array,
    required: true,
    default: () => [],
  },
  invalid: {
    type: Boolean,
    required: false,
    default: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
})

const { timeTo } = toRefs(props)
const emit = defineEmits(['update:timeTo'])
const timeToField = ref()

defineExpose({ timeToField })
</script>
